import React, { useState } from "react";
import { Container, Form, Button, Table, Alert, Badge } from "react-bootstrap";
import axios from "axios";

function App() {
  const [form, setForm] = useState({ tin: "", terminalId: "", mxikCode: "" });
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setData(null);
    try {
      const url = `https://tasnif.soliq.uz/api/cl-api/integration-mxik/get/information?page=0&size=25&mxikCode=${form.mxikCode}&type=1&terminalId=${form.terminalId}&tin=${form.tin}&lang=uz`;
      const response = await axios.get(url);
      setData(response.data);
    } catch (err) {
      setError("Ошибка при получении данных");
    }
  };

  return (
    <Container className="mt-5">
      <h2 className="mb-4">Проверка MXIK</h2>
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <Form.Group className="mb-3 col-md-3">
            <Form.Label>ИНН</Form.Label>
            <Form.Control name="tin" value={form.tin} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-3 col-md-3">
            <Form.Label>Terminal ID</Form.Label>
            <Form.Control
              name="terminalId"
              value={form.terminalId}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-3">
            <Form.Label>ИКПУ (MXIK код)</Form.Label>
            <Form.Control
              name="mxikCode"
              value={form.mxikCode}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-3 d-flex align-items-end">
            <Button type="submit" className="w-100">
              Поиск
            </Button>
          </Form.Group>
        </div>
      </Form>

      {error && (
        <Alert variant="danger" className="mt-4">
          {error}
        </Alert>
      )}

      {data && (
        <div className="mt-5">
          <h3>
            Разрешение на продажу на розлив:{" "}
            <Badge bg={data.permitted ? "success" : "danger"}>
              {data.permitted ? "ДА" : "НЕТ"}
            </Badge>
          </h3>

          {(data.data || []).map((item, index) => (
            <div key={index} className="mt-4 border p-3 rounded shadow-sm">
              <p>
                <strong>MXIK:</strong> {item.mxik}
              </p>
              <p>
                <strong>Штрихкод:</strong> {item.internalCode}
              </p>
              <p>
                <strong>Название:</strong> {item.name}
              </p>
              <p>
                <strong>Тип:</strong>{" "}
                {item.label === 1 ? (
                  <Badge bg="primary">Маркировочная продукция</Badge>
                ) : (
                  <Badge bg="secondary">Не маркировочная</Badge>
                )}
              </p>

              <h5 className="mt-3">Упаковки:</h5>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Код</th>
                    <th>Название (UZ)</th>
                    <th>Название (RU)</th>
                  </tr>
                </thead>
                <tbody>
                  {(item.packages || []).map((pkg, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{pkg.code}</td>
                      <td>{pkg.nameLat}</td>
                      <td>{pkg.nameRu}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ))}
        </div>
      )}

      <footer className="bg-light text-center py-3 mt-5 shadow-sm">
        <small className="text-muted">
          Разработано с любовью для лучших партнёров, выбирающих{" "}
          <a
            href="https://www.zetta.uz/ofd"
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>iikoFiscal</strong>
          </a>
        </small>
      </footer>
    </Container>
  );
}

export default App;
